import { c as _c } from "react/compiler-runtime";
import type { TextField } from '@payloadcms/plugin-form-builder/types';
import type React from 'react';
import type { FieldError, FieldErrorsImpl, FieldValues, Merge, UseFormRegister } from 'react-hook-form';
import { Required } from '@/features/payload-cms/components/form/required';
import { fieldIsRequiredText } from '@/features/payload-cms/components/form/static-form-texts';
import { useCurrentLocale } from '@/hooks/use-current-locale';
import type { Locale } from '@/types/types';
import { i18nConfig } from '@/types/types';
import type { JSX } from 'react';
type NumberInputProperties = {
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<FieldValues>>;
  placeholder?: string;
  registerAction: UseFormRegister<string & FieldValues>;
} & TextField;
const isPreviewMode = (): boolean => typeof globalThis !== 'undefined' && globalThis.location.href.includes('preview=true');
const renderPreviewError = (message: string): JSX.Element | null => isPreviewMode() ? <p className="text-sm text-red-800">{message}</p> : <></>;
export const Number: React.FC<NumberInputProperties> = t0 => {
  const $ = _c(38);
  const {
    name,
    label,
    registerAction,
    required: t1,
    error,
    placeholder
  } = t0;
  const requiredFromProperties = t1 === undefined ? false : t1;
  const locale = useCurrentLocale(i18nConfig);
  const hasError = error !== undefined;
  if (typeof label !== "string") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = renderPreviewError("Label must be a string!");
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (typeof name !== "string") {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = renderPreviewError("Name must be a string!");
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const t2 = hasError ? "bg-red-50 ring-red-500" : "ring-transparent";
  let t3;
  if ($[2] !== t2) {
    t3 = ["h-10 w-full rounded-md border-0 bg-green-100 px-4 py-2 font-['Inter'] text-base text-gray-600 shadow-sm ring-1 ring-inset", t2, "focus:ring-conveniat-green transition-all duration-200 placeholder:text-gray-400 focus:bg-white focus:ring-2 focus:outline-none focus:ring-inset"];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const inputClassNames = t3.join(" ");
  const t4 = requiredFromProperties ? fieldIsRequiredText[locale as Locale] : false;
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== inputClassNames || $[5] !== label || $[6] !== name || $[7] !== placeholder || $[8] !== registerAction || $[9] !== requiredFromProperties || $[10] !== t4) {
    const registerOptions = {
      required: t4
    };
    t10 = "mb-4";
    let t12;
    if ($[18] !== requiredFromProperties) {
      t12 = requiredFromProperties && <Required />;
      $[18] = requiredFromProperties;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    if ($[20] !== label || $[21] !== name || $[22] !== t12) {
      t11 = <label className="mb-1 block font-['Inter'] text-sm font-medium text-gray-500" htmlFor={name}>{label}{t12}</label>;
      $[20] = label;
      $[21] = name;
      $[22] = t12;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    t5 = name;
    t6 = "number";
    t7 = inputClassNames;
    t8 = placeholder;
    t9 = registerAction(name, registerOptions);
    $[4] = inputClassNames;
    $[5] = label;
    $[6] = name;
    $[7] = placeholder;
    $[8] = registerAction;
    $[9] = requiredFromProperties;
    $[10] = t4;
    $[11] = t10;
    $[12] = t11;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t12;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t12 = <input id={t5} type={t6} className={t7} placeholder={t8} {...t9} />;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== error || $[31] !== hasError) {
    t13 = hasError && <p className="mt-1 text-xs text-red-600">{(error as FieldError).message}</p>;
    $[30] = error;
    $[31] = hasError;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = <div className={t10}>{t11}{t12}{t13}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
};